import React from 'react';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import {Palette} from '@components/archiX6/palette';

export default function ArchiX6SidebarPalette({
	colorBorder,
	paletteCollapsed,
	setPaletteCollapsed,
	modelerReady,
	modeler,
	selectionMode,
	onToggleSelectionMode,
}) {
	return (
		<div
			style={{
				width: paletteCollapsed ? 36 : 220,
				minWidth: paletteCollapsed ? 36 : 220,
				flexShrink: 0,
				display: 'flex',
				flexDirection: 'column',
				background: '#f5f5f5',
				borderLeft: `1px solid ${colorBorder}`,
				zIndex: 10,
				overflow: 'hidden',
			}}
		>
			<div
				style={{
					display: paletteCollapsed ? 'none' : 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					padding: '4px 8px',
					borderBottom: `1px solid ${colorBorder}`,
					background: '#e9e9e9',
					flexShrink: 0,
					gap: 4,
				}}
			>
				<span style={{fontSize: 12, fontWeight: 600, color: '#666', flex: 1}}>Палитра</span>
				<button
					type="button"
					onClick={() => setPaletteCollapsed(true)}
					title="Свернуть палитру"
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: 24,
						height: 24,
						padding: 0,
						border: 'none',
						background: 'transparent',
						borderRadius: 4,
						cursor: 'pointer',
						color: 'rgba(0,0,0,0.65)',
					}}
				>
					<RightOutlined style={{fontSize: 12}} />
				</button>
			</div>
			<div
				className="archi-x6-palette-wrapper"
				style={{
					flex: 1,
					minHeight: 0,
					position: 'relative',
					overflow: 'hidden',
					width: '100%',
					display: paletteCollapsed ? 'none' : 'block',
				}}
			>
				{modelerReady && (
					<Palette
						modeler={modeler}
						selectionMode={selectionMode}
						onToggleSelectionMode={onToggleSelectionMode}
					/>
				)}
			</div>
			{paletteCollapsed && (
				<button
					type="button"
					onClick={() => setPaletteCollapsed(false)}
					title="Развернуть палитру"
					style={{
						width: '100%',
						flex: 1,
						minHeight: 48,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						padding: 0,
						border: 'none',
						background: 'transparent',
						cursor: 'pointer',
						color: 'rgba(0,0,0,0.65)',
					}}
				>
					<LeftOutlined style={{fontSize: 14}} />
				</button>
			)}
		</div>
	);
}
